import styled from 'styled-components'

import { IconProps, VerifiedId, VerifiedListingBadge } from '@/components/icons'

type StyleProps = IconProps & {
  width?: number
  height?: number
  position?: string
}

type Props = Omit<StyleProps, 'id' | 'aria-label'> & {
  type: keyof typeof ICONS
  verified: boolean | string
}

const withStyle = (Component: React.ComponentType) => styled(
  Component
)<StyleProps>`
  width: ${({ width }) => width || 24}px;
  height: ${({ height }) => height || 24}px;
  flex-shrink: 0;
  margin-top: ${({ top }) => top || 0}px;
  margin-right: ${({ right }) => right || 0}px;
  margin-bottom: ${({ bottom }) => bottom || 0}px;
  margin-left: ${({ left }) => left || 0}px;
  position: ${({ position }) => position || 'static'};
`

const StyledVerifiedId = withStyle(VerifiedId)

const StyledVerifiedListingBadge = withStyle(VerifiedListingBadge)

const ICONS: Record<string, React.FC<StyleProps>> = {
  id: props => (
    <StyledVerifiedId
      id="verified_id"
      aria-label="This user is ID/Businesss Licence verified"
      {...props}
    />
  ),
  listing: props => (
    <StyledVerifiedListingBadge
      id="verified_listing_badge"
      aria-label="This rental listing is address verified"
      {...props}
    />
  )
}

const VerifiedBadge: React.FC<Props> = ({ verified, type = 'id', ...rest }) => {
  const Badge = ICONS[type] || null
  return verified === 'verified' || verified === true ? (
    <Badge {...rest} />
  ) : null
}

export default VerifiedBadge
